// extracted by mini-css-extract-plugin
module.exports = {"container":"_da37c26a"};